import PropTypes from 'prop-types';

// material-ui
import { Tooltip, Box, List } from '@mui/material';

// project imports
import RenderEntity, {
    getMatchValueInEntity,
    // RENDER_ENTITY_FORMAT0,
    RENDER_ENTITY_FORMAT1,
    RENDER_ENTITY_FORMAT2
} from 'ui-component/renders/RenderEntity';

export const RENDER_ENTITYLIST_FORMAT0 = 0;
export const RENDER_ENTITYLIST_FORMAT1 = 1;
export const RENDER_ENTITYLIST_FORMAT2 = 2;
export const RENDER_ENTITYLIST_FORMAT3 = 3;

// ==============================|| RENDER GENERIC ENTITY LIST ||============================== //

const RenderEntityList = ({
    entityName = '',
    value = [],
    renderPattern = '',
    renderFormat = RENDER_ENTITYLIST_FORMAT0,
    maxNumberDisp = 5
    // ...others
}) => {
    let entities = [];

    switch (renderFormat) {
        case RENDER_ENTITYLIST_FORMAT0:
            entities = value
                ?.slice(0, maxNumberDisp || value?.length)
                ?.map((ent) => renderPattern.replace(/<(.*?)>/g, (match) => getMatchValueInEntity(match, ent)));

            if (maxNumberDisp && value?.length > maxNumberDisp) {
                entities.push('...');
            }

            return <Box>{entities.join(', ')}</Box>;
        case RENDER_ENTITYLIST_FORMAT1:
            entities = value?.slice(0, maxNumberDisp || value?.length)?.map((ent, index) => (
                <RenderEntity
                    key={`entity${entityName}${index}`}
                    entityName={entityName}
                    value={ent}
                    renderPattern={renderPattern}
                    renderFormat={RENDER_ENTITY_FORMAT1}
                    // {...others}
                />
            ));

            if (maxNumberDisp && value?.length > maxNumberDisp) {
                entities.push('...');
            }

            return <Box>{entities}</Box>;
        case RENDER_ENTITYLIST_FORMAT2:
            entities = value?.slice(0, maxNumberDisp || value?.length)?.map((ent, index) => (
                <RenderEntity
                    key={`entity${entityName}${index}`}
                    entityName={entityName}
                    value={ent}
                    renderPattern={renderPattern}
                    renderFormat={RENDER_ENTITY_FORMAT1}
                    // {...others}
                />
            ));

            if (maxNumberDisp && value?.length > maxNumberDisp) {
                entities.push('...');
            }

            return (
                <Tooltip title={entities}>
                    <Box>{value?.length || 0}</Box>
                </Tooltip>
            );
        case RENDER_ENTITYLIST_FORMAT3:
            entities = value?.slice(0, maxNumberDisp || value?.length)?.map((ent, index) => (
                <RenderEntity
                    key={`entity${entityName}${index}`}
                    entityName={entityName}
                    value={ent}
                    renderPattern={renderPattern}
                    renderFormat={RENDER_ENTITY_FORMAT2}
                    // {...others}
                />
            ));

            if (maxNumberDisp && value?.length > maxNumberDisp) {
                entities.push('...');
            }

            return <List>{entities}</List>;
        default:
            return <Box />;
    }
};

RenderEntityList.propTypes = {
    entityName: PropTypes.string,
    value: PropTypes.array,
    renderPattern: PropTypes.string,
    renderFormat: PropTypes.oneOf([
        RENDER_ENTITYLIST_FORMAT0,
        RENDER_ENTITYLIST_FORMAT1,
        RENDER_ENTITYLIST_FORMAT2,
        RENDER_ENTITYLIST_FORMAT3
    ]),
    maxNumberDisp: PropTypes.number
};

export default RenderEntityList;
